import { useState, useEffect } from 'react';

/**
 * Cycles through an array of progress messages at a fixed interval
 * while `isActive` is true. Returns the current message string.
 *
 * @param {boolean} isActive  – start / stop the rotation
 * @param {string[]} messages – pool of messages to cycle through
 * @param {number} intervalMs – milliseconds between swaps (default 2 000)
 * @returns {string} the current progress message
 */
export default function useProgressMessages(isActive, messages, intervalMs = 2000) {
    const [index, setIndex] = useState(0);
    const count = messages.length;

    useEffect(() => {
        if (!isActive) return;

        // Reset to first message when activation starts
        setIndex(0);

        const id = setInterval(() => {
            setIndex(prev => (prev + 1) % count);
        }, intervalMs);

        return () => clearInterval(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isActive, intervalMs, count]);

    // When not active, always show first message
    return isActive ? (messages[index] || messages[0]) : messages[0];
}
